module.exports = __webpack_public_path__ + "static/media/group--co-occupational-safety.c6f68b30.svg";